module.exports = __webpack_public_path__ + "img/hand-back-point-right.6f73fab8.svg";